// extracted by mini-css-extract-plugin
export default {"imageWrapper":"SH-z","twoColumnImage":"TH-z"};